(function (angular) {
  var serviceId = "signupService";

  angular
    .module("app")
    .factory(serviceId, ["$http", "_", function ($http, _) {
      function createSelfServiceUser(newUserSignup) {
        return $http.post("/api/Signup", newUserSignup);
      }

      function userExists(email) {
        return $http.get("/api/UserInfo/Exists?email=" + encodeURIComponent(email));
      }

      function getAccounts(username) {
        return $http.get("/api/Account?userName=" + encodeURIComponent(username));
      }

      function getUser(username) {
        return $http.get("/api/UserInfo/Get?email=" + encodeURIComponent(username));
      }

      function sendVerification(email, featureLevel) {
        var featureLevelQuery = "";
        if (featureLevel) {
          featureLevelQuery = "&featureLevel=" + featureLevel;
        }

        return $http.post("/api/Signup/SendVerificationToken?email=" + encodeURIComponent(email) + featureLevelQuery);
      }

      function canUserSignupForTrial(accounts) {
        var isAssociatedWithPCM = _.findIndex(accounts, {
          AssociatedWithPCM: true
        }) >= 0;
        return !isAssociatedWithPCM;
      };

      return {
        createSelfServiceUser: createSelfServiceUser,
        userExists: userExists,
        getAccounts: getAccounts,
        getUser: getUser,
        sendVerification: sendVerification,
        canUserSignupForTrial: canUserSignupForTrial
      };
    }]);
})(angular);



// WEBPACK FOOTER //
// ./app/account/signUp.service.js